var _excluded = ["label"];

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

export var defaultFormatSelectedValue = option => option.label;
export var checkHasSections = options => options.some(option => 'options' in option);
export var getOptionsGroupedBySection = options => {
  var optionsWithIndex = options.map((option, index) => _objectSpread(_objectSpread({}, option), {}, {
    index
  }));
  var optionsBySectionTitle = optionsWithIndex.reduce((acc, option) => {
    var {
      section: {
        label: currentSectionLabel
      }
    } = option,
        currentSectionMetadata = _objectWithoutProperties(option.section, _excluded);

    acc[currentSectionLabel] = {
      section: currentSectionMetadata,
      options: optionsWithIndex.filter(option => option.section.label === currentSectionLabel)
    };
    return acc;
  }, {});
  return optionsBySectionTitle;
};
export var getOptionsWithSection = sections => sections.flatMap(section => section.options.map(option => _objectSpread(_objectSpread({}, option), {}, {
  section: section.metadata
})));
//# sourceMappingURL=BaseSelect.utils.js.map